export default "__VITE_ASSET__BDfHsf1h__"